export const INVOICE_LEVEL_DISCOUNT_COLUMNS = [
  {
    key: 'discountAmount',
    label: 'createInvoice.e_invoice_level_discount',
    body: (rowItem) => `${Number(rowItem.discountAmount).toFixed(3)} BHD`,
    _props: { scope: 'col' },
  },
  {
    key: 'amountSubjectToDiscount',
    label: 'createInvoice.amount_subject_to_discount',
    body: (rowItem) =>
      rowItem.amountSubjectToDiscount
        ? `${Number(rowItem.amountSubjectToDiscount).toFixed(3)} BHD`
        : '-',
    _props: { scope: 'col' },
  },
  {
    key: 'rate',
    label: 'createInvoice.discount_rate',
    body: (rowItem) => (rowItem.rate ? `${rowItem.rate}%` : '-'),
    _props: { scope: 'col' },
  },
  {
    key: 'discountVatRate',
    label: 'createInvoice.discount_vat_rate',
    body: (rowItem) =>
      rowItem.discountVatRate ? `${rowItem.discountVatRate}%` : '-',
    _props: { scope: 'col' },
  },
];
